import { render, staticRenderFns } from "./CreateActivationLink.vue?vue&type=template&id=10bb0cc4"
import script from "./CreateActivationLink.vue?vue&type=script&lang=js"
export * from "./CreateActivationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports